import { instanceForBackend } from '../../config/axios.config';
import { BACKEND_API } from '../../constants/backendApi';
export var webhookService = {
    getWebhooks: function (shopId) { return instanceForBackend.get("".concat(BACKEND_API.GET_WEBHOOKS_BY_SHOP_ID, "/").concat(shopId)); },
    createWebhook: function (data) {
        return instanceForBackend.post(BACKEND_API.CREATE_OR_UPDATE_WEBHOOK, data);
    },
    updateWebhook: function (data) {
        return instanceForBackend.patch("".concat(BACKEND_API.CREATE_OR_UPDATE_WEBHOOK, "/").concat(data.webhook_id), data);
    },
    deleteWebhooksByShopId: function (shopId) { return instanceForBackend.delete("".concat(BACKEND_API.DELETE_WEBHOOKS_BY_SHOP_ID, "/").concat(shopId)); },
};
